import { useSelector } from 'react-redux'
import { ChartSnapshot } from '../chart.typings'
import { selectChartPanes } from '../../../selectors/chart'
import React, { createContext, memo } from 'react'
import ChartPane from '../chartPane/chartPane'
import { TradeOptions } from '../../../reducer/scalper.reducer'

/** Stable id per pane DOM node so ChartPane remounts when lightweight-charts replaces pane elements (avoids portal/commit on detached nodes). */
const chartPaneHostKeys = new WeakMap<HTMLDivElement, number>()
let nextChartPaneHostKey = 1
function chartPaneHostKey(el: HTMLDivElement) {
    let k = chartPaneHostKeys.get(el)
    if (k === undefined) {
        k = nextChartPaneHostKey++
        chartPaneHostKeys.set(el, k)
    }
    return k
}

export type ChartMetadataProps = {
    viewKey: string
    paneElements: HTMLDivElement[]
    chartSnapshot: ChartSnapshot
    showLogo: boolean
    primary: boolean
    screenerChart: boolean,
    tradeOptions?: TradeOptions,
    onSecuritySelected?: (key: string, expressionMode: boolean, securities: string[]) => void
}

export const ChartMetadataContext = createContext<ChartSnapshot>({})

const ChartMetadata: React.FC<ChartMetadataProps> = memo(({
                                                              viewKey,
                                                              paneElements,
                                                              chartSnapshot,
                                                              showLogo,
                                                              primary,
                                                              screenerChart,
                                                              tradeOptions,
                                                              onSecuritySelected
                                                          }) => {
    const chartPanes = useSelector(selectChartPanes(viewKey))
    if (!paneElements.length || !chartPanes.length) return null

    return <ChartMetadataContext.Provider value={chartSnapshot}> {
        paneElements.map((ele, i) => <ChartPane id={chartPanes[i]} viewKey={viewKey} container={ele} index={i}
                                                key={`${viewKey}-${chartPanes[i] ?? i}-${i}-h${chartPaneHostKey(ele)}`} showLogo={showLogo} screenerChart={screenerChart}
                                                primaryChart={primary} onSecuritySelected={onSecuritySelected} tradeOptions={tradeOptions} />)
    }</ChartMetadataContext.Provider>
})

ChartMetadata.displayName = 'ChartMetadata'

export { ChartMetadata }